// #2868 — the scribe's chosen sort for the class list. Default stays the
// strict scheduled-time order #632 shipped ("time"); "classNumber" is the
// opt-in alternative.
//
// Persisted PER SESSION in sessionStorage (same reasoning as
// startScoringConfirm.js, #2355): opening a class and coming back to the list
// unmounts ClassList, and a kiosk reload mid-show must not silently snap the
// scribe back to time order. Nothing durable: a new session starts on "time".
// try/catch'd so a browser with storage disabled degrades to the default.
export const CLASS_SORT_TIME = "time";
export const CLASS_SORT_CLASS_NUMBER = "classNumber";
export const CLASS_SORT_OPTIONS = [CLASS_SORT_TIME, CLASS_SORT_CLASS_NUMBER];
export const DEFAULT_CLASS_SORT = CLASS_SORT_TIME;

const STORAGE_KEY = "scribe-fe.classListSort";

/** @returns {string} the stored sort, or DEFAULT_CLASS_SORT if unset/invalid/unreadable. */
export function getClassListSort() {
  try {
    const v = sessionStorage.getItem(STORAGE_KEY);
    return CLASS_SORT_OPTIONS.includes(v) ? v : DEFAULT_CLASS_SORT;
  } catch {
    return DEFAULT_CLASS_SORT;
  }
}

export function setClassListSort(value) {
  if (!CLASS_SORT_OPTIONS.includes(value)) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Storage unavailable: the choice just lasts until the list unmounts.
  }
}
